"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTgeekIconSVG = void 0;
const React = __importStar(require("react"));
const NFTgeekIconSVG = () => React.createElement("svg", { width: "1em", height: "1em", version: "1.0", viewBox: "0 0 283.5 323.25", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fill: "currentColor", d: "m186.58 1.9429-22.506 41.566h-0.11418l-20.608 38.029-0.94433-9.3568-3.4409-38.02h-18.353l-23.454 43.229-5.3326 9.8259-11.718-33.986h-19.075l-18.362 33.872-9.471 17.405h16.581l1.0708-1.7776 18.828-34.81 11.968 34.341 0.70671 2.2466h16.822l1.0678-2.1232 23.448-42.883 2.3701-4.4932 4.2618 46.661 0.23764 2.7219 0.23145 0.11726 0.36107 0.12345 14.091 0.12343h2.1294l0.11727-0.24688 1.0678-2.1232 21.562-39.56 1.7775-3.3236 8.0484-14.807 0.7067-1.185 10.313-19.183 1.2992 24.164 0.11418 2.7219 0.11726 2.2466 1.901 49.04 0.11417 2.009h16.936l0.9474-1.7776 23.33-42.982 8.4187-15.399 0.35182-0.59252h-16.705l-19.661 36.119-0.83014-21.436v-0.46907l-0.23146-4.5118-0.83013-15.387-1.7776-36.128zm-153.85 123.65v82.434h82.434v-29.373h45.713v58.159h-55.07v19.535h74.617v-48.321h62.887v-82.434h-82.434v33.527h-45.713v-33.527zm0 101.74v92.976h210.94v-92.976h-19.544v73.429h-171.85v-73.429z" }));
exports.NFTgeekIconSVG = NFTgeekIconSVG;
